import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/Layout';
import StatsGrid from '../components/visualizations/StatsGrid';
import ContractInsights from '../components/visualizations/ContractInsights';
import ContractsTable from '../components/visualizations/ContractsTable';

const Dashboard = () => {
    const [metrics, setMetrics] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simulated data load - in production this would come from API
        const mockMetrics = {
            total_investment: 2847500000,
            total_contracts: 919,
            flagged_contracts: 47,
            unique_suppliers: 312,
        };

        // Simulate network delay for realistic loading state
        setTimeout(() => {
            setMetrics(mockMetrics);
            setLoading(false);
        }, 500);
    }, []);

    return (
        <Layout>
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="mb-8">
                    <h2 className="text-3xl font-display font-bold text-white mb-2">Instituto i³</h2>
                    <div className="flex items-center gap-3 flex-wrap">
                        <p className="text-zinc-500 font-mono text-sm">Monitor de Gasto Público · CDMX 2020</p>
                        <span className="bg-green-500/10 text-green-500 text-xs font-mono px-2 py-0.5 rounded border border-green-500/20">
                            PHOENIX 2.2
                        </span>
                    </div>
                </div>

                {/* Key Metrics */}
                <StatsGrid metrics={metrics} loading={loading} />

                {/* Insights Visualizations */}
                <div className="mb-8">
                    <h3 className="text-xl font-display font-bold text-white mb-4">Análisis de Contrataciones</h3>
                    <ContractInsights />
                </div>

                {/* Contracts Table */}
                <div className="mb-6">
                    <ContractsTable />
                </div>
            </div>
        </Layout>
    );
};

export default Dashboard;
